const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_BOTTOM_TRIGGER_CLASSNAME = 'scroll-trigger--bottom';
const SCROLL_ANIMATION_HORIZONTAL_TRIGGER_CLASSNAME = 'scroll-trigger--horizontal';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_ONSCREEN_CLASSNAME = 'scroll-trigger--onscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

gsap.registerPlugin(SplitText);

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }

      gsap.delayedCall(0.01, () => {
        elementTarget.classList.add(SCROLL_ANIMATION_ONSCREEN_CLASSNAME);
      });
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      // element.target.classList.remove(SCROLL_ANIMATION_ONSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(
    rootEl.querySelectorAll(
      `.${SCROLL_ANIMATION_TRIGGER_CLASSNAME}:not(.${SCROLL_ANIMATION_HORIZONTAL_TRIGGER_CLASSNAME}, .${SCROLL_ANIMATION_BOTTOM_TRIGGER_CLASSNAME})`
    )
  );
  const horizontalAnimationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_HORIZONTAL_TRIGGER_CLASSNAME)
  );
  const bottomAnimationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_BOTTOM_TRIGGER_CLASSNAME)
  );

  if (animationTriggerElements.length > 0) {
    if (isDesignModeEvent) {
      animationTriggerElements.forEach((element) => {
        element.classList.add('scroll-trigger--design-mode');
      });
      return;
    }

    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: '0px 0px -10% 0px',
    });

    animationTriggerElements.forEach((element) => observer.observe(element));
  }

  if (horizontalAnimationTriggerElements.length > 0) {
    if (isDesignModeEvent) {
      horizontalAnimationTriggerElements.forEach((element) => {
        element.classList.add('scroll-trigger--design-mode');
      });
      return;
    }

    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: '0px -12.5% 0px 0px',
    });

    horizontalAnimationTriggerElements.forEach((element) => observer.observe(element));
  }

  if (bottomAnimationTriggerElements.length > 0) {
    if (isDesignModeEvent) {
      bottomAnimationTriggerElements.forEach((element) => {
        element.classList.add('scroll-trigger--design-mode');
      });
      return;
    }

    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: '0px 0px 0px 0px',
    });

    bottomAnimationTriggerElements.forEach((element) => observer.observe(element));
  }
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

function split(el, type) {
  // Add aria-label to the element if it doesn't exist
  if (!el.getAttribute('aria-label')) {
    el.setAttribute('aria-label', el.innerHTML.replace(/\n|<.*?>/g, ''));
  }

  // Loop through child elements and hide from screen readers
  el.querySelectorAll('*').forEach((child) => {
    child.setAttribute('aria-hidden', 'true');
  });

  if (type === 'chars') {
    // Split the text in to lines first
    const splitEl = new SplitText(el, { type: 'lines', linesClass: 'line', tag: 'span' });

    splitEl.lines.forEach((line) => {
      line.innerHTML = `<div class="line-inner">${line.innerHTML}</span>`;

      // Split by chars and add animation orders
      const chars = new SplitText(line, { type: type, charsClass: 'char', tag: 'span' });

      chars.chars.forEach((char, charIndex) => {
        char.setAttribute('style', `--animation-order: ${charIndex};`);
      });
    });
  } else {
    // Split the text in to words
    const splitEl = new SplitText(el, { type: 'words', wordsClass: 'word', tag: 'span' });

    splitEl.words.forEach((line) => {
      line.innerHTML = `<div class="word-inner">${line.innerHTML}</span>`;
    });
  }

  gsap.delayedCall(0.05, () => {
    el.classList.add('split');
  });
}

function initializeSplitTexts(rootEl = document) {
  const splitCharElements = rootEl.querySelectorAll('.js-split-char');
  const splitLineElements = rootEl.querySelectorAll('.js-split-line');

  if (splitCharElements.length === 0 && splitLineElements.length === 0) return;

  splitCharElements.forEach((element) => {
    split(element, 'chars');
  });

  splitLineElements.forEach((element) => {
    split(element, 'words');
  });
}

function checkFontsforSplitText() {
  // Not supported in IE11 - check with Ross if a polyfill is needed
  document.fonts.ready.then(() => {
    initializeSplitTexts();
  });
}

initializeScrollAnimationTrigger();

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  checkFontsforSplitText();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:load', (event) => initializeSplitTexts(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
